/**
 * @generated SignedSource<<453eb63a69fb175ba9715d43c116eb8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useSearchModeMutation$data = {
  readonly __id: string;
  readonly " $fragmentType": "useSearchModeMutation";
};
export type useSearchModeMutation$key = {
  readonly " $data"?: useSearchModeMutation$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSearchModeMutation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useSearchModeMutation",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "9ab33cc8a353881fcc5eed1cf1e2531a";

export default node;
